/**
 * Legacy/bookmark catcher for the old customer "home" URL. Sends a
 * `/c/:cust_id/home` hit to that customer's plant list — react-router's
 * `Navigate` does not interpolate params into a bare pattern string, so
 * the redirect target has to be built from the route params directly.
 */
import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

import { customerPlantsPath } from '@sophocles/router/paths';

function CustomerHomeRedirect() {
  const { cust_id } = useParams();
  return <Navigate to={customerPlantsPath({ cust_id })} replace />;
}

export default CustomerHomeRedirect;
